@if (currentRoute === 'saml-sso') {
<router-outlet></router-outlet>
} @else if (auth.isAuthenticated$ | async) {
<div id="app-wrapper">
  @if (user$ | async; as loggedinuser) {
  <div
    class="compact-masthead"
    fxLayout="row"
    fxLayoutAlign="start center"
    fxLayoutGap="10px"
  >
    <ats-masthead
      currentModule="SupplyChainV2"
      [person]="loggedinuser"
      [flagsmithEnvId]="mastheadFlagsmithEnvId"
      [buildNumber]="buildNumber"
    ></ats-masthead>
    <div fxFlex></div>
    <efp-masthead-uservoice [person]="loggedinuser"></efp-masthead-uservoice>
    <efp-masthead-user
      [person]="loggedinuser"
      [showThemeSwitch]="(featureToggles$ | async)?.light_dark_mode_switch || false"
    ></efp-masthead-user>
  </div>
  <div class="build">{{ buildNumber }}</div>
  <div
    id="viewport"
    class="viewport"
  >
    <ngx-loading-bar
      [fixed]="false"
      height="3px"
      color="#139DEB"
      [includeSpinner]="false"
    ></ngx-loading-bar>
    <router-outlet></router-outlet>
  </div>
  }
</div>
} @else {
<div style="margin: 16px 26px">
  <svg
    width="24"
    height="24"
    stroke="var(--efp-viewport-color, transparent)"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <style>
    .spinner_V8m1 {
      transform-origin: center;
      animation: spinner_zKoa 2s linear infinite;
    }
    .spinner_V8m1 circle {
      stroke-linecap: round;
      animation: spinner_YpZS 1.5s ease-in-out infinite;
    }
    @keyframes spinner_zKoa {
      100% {
        transform: rotate(360deg);
      }
    }
    @keyframes spinner_YpZS {
      0% {
        stroke-dasharray: 0 150;
        stroke-dashoffset: 0;
      }
      47.5% {
        stroke-dasharray: 42 150;
        stroke-dashoffset: -16;
      }
      95%,
      100% {
        stroke-dasharray: 42 150;
        stroke-dashoffset: -59;
      }
    }
    </style>
    <g class="spinner_V8m1">
      <circle
        cx="12"
        cy="12"
        r="9.5"
        fill="none"
        stroke-width="3"
      ></circle>
    </g>
  </svg>
</div>
} @if (timezone$ | async) { } @if (authError$ | async) { }
